import React from "react";
import PanToolIcon from '@mui/icons-material/PanTool';

const NotAuthorized = () => {
    return <div className="content page-main-inner cadrant-full-page">
        <div className="content-message">
            <p className="code-error">Accès interdit <span className="danger">403</span></p>
            <PanToolIcon className="icon-error" />
            <p className="message-error">Vous n'avez pas le rôle nécessaire pour accéder à cette page !</p>
        </div>

    </div>
}

export default NotAuthorized
